import React from 'react';

import { ResultsNone } from '../../../../common/ui/results-none';
import { ResultsNoneContentCleared } from '../../../../common/ui/results-none/results-none-content-cleared';
import ResultsPaginationFooter from '../../../../common/ui/results-pagination-footer';
import { SearchResultsList } from '../../../../common/ui/search-result-list';
/* eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports */
import { SearchResult } from '../search-result';
/* eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports */
import type { SearchResultsListRendererProps } from '../types';

export const SearchResultsListDefaultRenderer = ({
	containsSearchResults,
	edgesToDisplay,
	cloudId,
	appMode,
	searchQuery,
	thirdPartyConfigs,
	selectedProduct,
	primaryProduct,
	searchSessionId,
	originalQuery,
	availableProducts,
	logError,
	teamNames,
	issueStatuses,
	linkedPRs,
	is3pGroupingEnabled,
	smartAnswersPortalRef,
	mainContentWidth,
	wasContentClearedBySpaceChange,
	clearSpaceFilter,
	clearFilters,
	getSelectedFilters,
	cursor,
	isLoadingNext,
	fetchNextPage,
}: SearchResultsListRendererProps): React.JSX.Element => (
	<SearchResultsList containsSearchResults={containsSearchResults}>
		{containsSearchResults ? (
			edgesToDisplay.map(
				(edge, position) =>
					edge?.node && (
						<SearchResult
							key={edge.node.id}
							node={edge.node}
							position={position}
							cloudId={cloudId}
							appMode={appMode}
							searchQuery={searchQuery}
							thirdPartyConfigs={thirdPartyConfigs}
							selectedProduct={selectedProduct}
							primaryProduct={primaryProduct}
							searchSessionId={searchSessionId}
							originalQuery={originalQuery}
							availableProducts={availableProducts}
							logError={logError}
							compassTeamName={teamNames[edge.node.id]}
							jiraIssueStatus={issueStatuses[edge.node.id]}
							jiraLinkedPRs={linkedPRs[edge.node.id]}
							is3pGroupingEnabled={is3pGroupingEnabled}
							smartAnswersPortalRef={smartAnswersPortalRef}
							mainContentWidth={mainContentWidth}
						/>
					),
			)
		) : wasContentClearedBySpaceChange ? (
			<ResultsNoneContentCleared
				selectedProduct={selectedProduct}
				clearSpaceFilter={clearSpaceFilter}
				clearFilters={clearFilters}
			/>
		) : (
			<ResultsNone
				filtersEnabled={!!selectedProduct || getSelectedFilters().hasFiltersSelected}
				clearFilters={clearFilters}
			/>
		)}
		<ResultsPaginationFooter
			cursor={cursor}
			isLoading={isLoadingNext}
			fetchNextPage={fetchNextPage}
		/>
	</SearchResultsList>
);
